export default __webpack_public_path__ + "static/media/collection-img-men.c78cb30e.jpg";